module.exports = __webpack_public_path__ + "img/3.bc3ce3be.jpg";